export const getHighlights = () => {
  const allHighlights = $('[data-highlight]')
  const visibleHighlights = allHighlights.filter(function () {
    return $(this).closest('.d-none').length === 0
  })
  return visibleHighlights
}

export const scrollToElement = (element) => {
  const resumenIaContent = element.closest('.resumen-ia-content')
  if (resumenIaContent && resumenIaContent.classList.contains('collapsed')) {
    document.dispatchEvent(new CustomEvent('resumen-ia:expand'))
    setTimeout(() => {
      element.scrollIntoView({ behavior: 'smooth' })
    }, 100)
    return
  }

  element.scrollIntoView({ behavior: 'smooth' })
}
